<template>
    <div class="room-status-page">

      <div class="header" @click="handleDialogDate">
        <div>{{roomDateRangeValue[0]}}<span>~</span>{{roomDateRangeValue[1]}}</div>
        <div >更换日期</div>
      </div>
      
      <div class="store-wrap">
          <div
            class="store-item"
            :class="{ active: storeSN == item.sn }"
            @click="searchStore(item.sn)"
            v-for="item in storesData"
            :key="item.sn"
          >
          {{ item.name }}
        </div>
      </div>

      <div class="scroll-wrapperPC">
        <div class="scroll-content"  :style="'width:'+tableContainerWith+'px;'">
   
          <!-- 日期表头 --> 
          <div class="date-header">

            <div class="date-item"
              :class="{ today: item.isToday }"
              v-for="item in roomData['dateRange']"
              :key="item.date"
            >
              {{ item.date }}<br>{{ item.weekday }}
            </div>
      
          </div>


           <!--有合同，有定金:蓝色                1 #409EFF-->
           <!--有合同，没有支付单:黄色             2 #E6A23C-->
           <!--有合同，有支付单，确定付款:绿色     3 #67C23A -->
           <!--预留会议室:红色                    4 #F56C6C-->

          <!-- 房态列表 -->
          <div class="room-list">
                
            <div class="room-row" v-for="(item, idx) in roomData['rooms']" :key="idx">
              <div class="room-name"> {{item.room_number}} </div>
              <div class="room-days">

                 <div class="day-cell" v-for="(item2, dIdx) in item['dateRange']" :key="dIdx">

                    <div v-for=" (item3,index,key) in item2['dateArry']">

                          <div  class="status " v-if="!item3['order']" >
                                 未使用
                          </div>

                          <div   @click="handlDetail(item3['order']['sn'])" v-if="item3['order'] && item3['order']['contracts'] && item3['order']['contracts']['receivables']>0"   class="status content_status_1 status_color">
                              <div class="item_name">{{item3['order']['customer_name']}}</div>
                              <div class="item_name">{{item3['order']['number_people']}}人</div>
                              <div class="item_name">{{item3['order']['start_time']}}</div>
                          </div>

                          <div @click="handlDetail(item3['order']['sn'])"  v-if="item3['order'] && (!item3['order']['contracts']) && item3['order']['amount']>0"   class="status content_status_2 status_color">
                              <div class="item_name">{{item3['order']['customer_name']}}</div>
                              <div class="item_name">{{item3['order']['number_people']}}人</div>
                              <div class="item_name">{{item3['order']['start_time']}}</div>

                          </div>

                          <div @click="handlDetail(item3['order']['sn'])"  v-if="item3['order'] && item3['order']['contracts'] && item3['order']['contracts']['receivables'] <= 0"   class="status content_status_3 status_color">
                               <div class="item_name">{{item3['order']['customer_name']}}</div>
                              <div class="item_name">{{item3['order']['number_people']}}人</div>
                              <div class="item_name">{{item3['order']['start_time']}}</div>
                          </div>

                          <div  @click="handlDetail(item3['order']['sn'])"  v-if="item3['order'] && (!item3['order']['contracts']) && item3['order']['amount']==0"   class="status content_status_4 status_color">
                                              <div class="item_name">{{item3['order']['customer_name']}}</div>
                              <div class="item_name">{{item3['order']['number_people']}}人</div>
                              <div class="item_name">{{item3['order']['start_time']}}</div>
                          </div>

                    </div>

                  </div>
              </div>

            </div>

          </div>

        </div>
      </div>

      <van-dialog v-model="dialogDatePop" title="选择时间" show-cancel-button  @confirm="searchConfirm"> 
 
        <div class="dialogDate">
            <div class="dialogDateRow" @click="selectDate(0)"> <span class="dialogDateLable">开始时间</span> <span class="dialogDateValue">{{beignDate}}</span></div>
            <div class="dialogDateRow" @click="selectDate(1)"> <span class="dialogDateLable">结束时间</span> <span class="dialogDateValue">{{endDate}}</span></div>
        </div>

      </van-dialog>

      <van-popup v-model="dialogDate" round position="bottom" :style="{ height: '50%' }" >
        <van-datetime-picker
          @confirm="dateConfirm" 
          @cancel="dateCancel"
          v-model="currentDate"
          type="date"
        />
       </van-popup>

       <van-popup v-model="dialogDetail" round position="bottom" :style="{ height: '90%' }" >
          
          <div style="padding:10px;">
            <el-descriptions title="基础信息" :column="2"  border  direction="vertical">


                <el-descriptions-item>
                <template slot="label">
                    <i class="el-icon-user"></i>
                    客户
                  </template>
                  {{orderDetailData["customer_text"]}}
                </el-descriptions-item>

                <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  销售人员
                </template>
                {{orderDetailData["staff_text"]}}
                </el-descriptions-item>

                <el-descriptions-item>
                <template slot="label">
                  会议室号
                </template>
                {{orderDetailData["rooms_text"]}}
                </el-descriptions-item>

                <el-descriptions-item>
                <template slot="label">
                  日期
                </template>
                {{orderDetailData["on_site_time"]}}
                </el-descriptions-item>

                <el-descriptions-item>
                <template slot="label">
                  时间类型
                </template>
                {{orderDetailData["time_type_text"]}}
                </el-descriptions-item>


                <el-descriptions-item>
                <template slot="label">
                  时段
                </template>
                {{orderDetailData["start_time"]}}
                </el-descriptions-item>






                <el-descriptions-item :span="2">
                <template slot="label" >
                  人数
                </template>
                {{orderDetailData["number_people"]}}
                </el-descriptions-item>



                <el-descriptions-item v-if='orderDetailData["amount"]'>
                <template slot="label">
                  销售金额
                </template>
                {{orderDetailData["amount"]}}
                </el-descriptions-item>


                <el-descriptions-item v-if='orderDetailData["discount"]'>
                <template slot="label">
                  销售折扣
                </template>
                {{orderDetailData["discount"]}}
                </el-descriptions-item>



                <el-descriptions-item :span="2">
                <template slot="label" >
                  备注
                </template>
                {{orderDetailData["remark"]}}
                </el-descriptions-item>



                <el-descriptions-item :span="2">
                <template slot="label">
                  桌型
                </template>
                {{orderDetailData["table_types"]}}
                </el-descriptions-item>



                <el-descriptions-item :span="2">
                <template slot="label">
                  设备配套
                </template>
                {{orderDetailData["option_service"]}}
                </el-descriptions-item>





                </el-descriptions>

                <div class="order_title">常用联系人信息</div> 

                <el-table :data="orderDetailData['contact']" style="width: 100%">
                  <el-table-column  prop="name" label="姓名" width="150"></el-table-column>
                  <el-table-column  prop="phone" label="手机" ></el-table-column>
                  <el-table-column  prop="wx" label="微信" ></el-table-column>
                </el-table>

                <div class="order_title">增值业务</div>
                  
                <el-table :data="orderDetailData['added_services']" style="width: 100%">
                <el-table-column  prop="on_date" label="时间" width="150"></el-table-column>
                <el-table-column  prop="value_added_services_name" label="类型" ></el-table-column>
                <el-table-column  prop="value_added_services_goods_name" label="名称" ></el-table-column>
                <el-table-column  prop="quantity" label="数量" width="100" ></el-table-column>
                </el-table>

          </div>
    
       </van-popup>

  </div>
</template>


<script>
 import {getRooms,getStores,getRoomDate,getOrderDetailData} from "../api/api.js";

  export default {
    name: "RoomStatus",
    components: {

    },
    data() {
      return {

    
       tableContainerWith:0,

        roomCurDate:null,
        roomDateRangeValue:[],

        storeSN:null,
        storesData:[],

        roomData:[],
        
        dialogDate:false,
        dialogDatePop:false,
        currentDate: new Date(),

        dialogDateType:0,
        beignDate:null,
        endDate:null,
        dialogDetail:false,
        
        orderDetailData:[],

      };
    },
    created() {



    },

    beforeDestroy() {


    },
    
    methods: {

      intPage(){
        this.getRoomDateData();
      },

      getIntData(){
        const now = new Date();
        // 本月1号：年、月不变，日期设为1
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        // 本月最后一天：月份+1，日期设为0（自动回退）
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        // 补零函数：1→01，9→09，10+保持不变（处理月份/日期）
        const addZero = num => num < 10 ? `0${num}` : num;

        // 格式化函数：把Date对象转成 YYYY-MM-DD 格式
        const formatDate = date => {
          const year = date.getFullYear();
          const month = addZero(date.getMonth() + 1); // 月份是0基，需+1再补零
          const day = addZero(date.getDate());
            return `${year}-${month}-${day}`;
        };

        let firstDayF=formatDate(firstDay);
        let lastDayF=formatDate(lastDay);

        this.getRoomsListData();

      },

      getStoresData(){
        let data={};
        getStores(data).then(response => {
            if(response.code == 200) {
              this.storesData=response.data;
              this.storeSN=this.storesData[0].sn;
              this.getRoomsData();
            }
          })
          .catch(error => {
            console.log(error);
          });
      },

      getRoomDateData(){

        let data={};
        getRoomDate(data).then(response => {
            if(response.code == 200) {
              this.roomCurDate=response.data;
              this.roomDateRangeValue =response.data["weekRangeValue"];
              this.beignDate=this.roomDateRangeValue[0];
              this.endDate =this.roomDateRangeValue[1];
              this.getStoresData();
            }
          })
          .catch(error => {
            console.log(error);
          });

      },

      getRoomsData(){

          if(!Array.isArray(this.roomDateRangeValue)){
            this.getRoomDateData();
            return;
          }

        let data={
            "option":this.optionType,
            "storeSN":this.storeSN,
            "roomDateRangeValue":this.roomDateRangeValue,
        };
        getRooms(data).then(response => {
            if(response.code == 200) {
                this.roomData=response.data; 
                this.tableContainerWith=this.roomData['dateRange'].length * 80;
            }
          })
          .catch(error => {
            console.log(error);
          });

      },

      handleDialogDate(){
        this.dialogDatePop=true;
      },

      dateConfirm(){

        this.dialogDate=false;


        const date = new Date(this.currentDate);
        // 获取年月日
        const year = date.getFullYear();
        const month = date.getMonth() + 1;  // 月份从0开始，需要+1
        const day = date.getDate();
        // 格式：2026-06-30
        const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        console.log(formattedDate); // "2026-06-30"
        if(this.dialogDateType==0){
          this.beignDate=formattedDate;
        }

        if(this.dialogDateType==1){
          this.endDate=formattedDate;
        }

      },

      dateCancel(){
        this.dialogDate=false;
      },

      selectDate(e){
        this.dialogDateType=e;
        this.dialogDate=true;
      },

      searchConfirm(){
        this.roomDateRangeValue=[ this.beignDate,this.endDate];
        this.getRoomsData();
      },

      searchStore(sn){
        this.storeSN = sn;
        this.getRoomsData();
      },

      handlDetail(sn){

      let data={
        "sn":sn
      }
     getOrderDetailData(data).then(response => {
          if(response.code == 200) {

            this.dialogDetail=true;
            this.orderDetailData=response.data;

          }
      })
        .catch(error => {
          console.log(error);
       })

     },
    },

    mounted() {
      this.intPage();
    },

  };
</script>

 <style >  


  /* 全局关闭整个页面上下/左右弹性回弹 */


  /* 自定义滚动容器 单独关闭弹性 */
  .scroll-wrap {
    overflow: auto;
    overscroll-behavior: none;
    -webkit-overflow-scrolling: auto;
  }
  .room-status-page {
    background: #f5f7fa;
    color: #333;
    -webkit-tap-highlight-color: transparent;
  }

   .room-status-page  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  }

  
  /* 顶部导航 */
  .header {
    display: flex;
    justify-content: space-between;
    padding:15px;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    position: sticky;
    top: 0;
    z-index: 99;
    font-size:14px;
    background-color:#f1f1f1;
  }
  
  /* 门店横向滚动 */
  .store-wrap {
    background: #fff;
    padding: 10px 12px;
    overflow-x: auto;
    white-space: nowrap;
    border-bottom: 1px solid #eee;
  }
  .store-wrap::-webkit-scrollbar {
    display: none; /* 直接隐藏 */
  }
  .store-item {
    display: inline-block;
    padding: 6px 12px;
    margin-right: 8px;
    border-radius: 15px;
    font-size: 13px;
    background: #eff6ff;
    color: #3b82f6;
  }
  .store-item.active {
    background: #3b82f6;
    color: #fff;
  }
  
  /* 日期横向表头 + 内容同步滚动 */
  .scroll-wrapperPC {
    overflow-x: auto;
    overflow-y: auto;
    height: calc(100vh - 120px);
    overscroll-behavior: none;
    -webkit-overflow-scrolling: auto;

  }


  .scroll-content {

  }

  .room-name{
      position: sticky;
      left: 0;
      padding:2px;
      border-bottom: 1px solid #eee;
      width:100vw;
      font-size: 12px;
      font-weight: bold;
  }
  
  /* 日期横向表头 */
  .date-header {
      position: sticky;
      top: 0;
      background: #fff;
      display: flex;
      border-bottom: 1px solid #eee;
      z-index:999;

  }
  .date-item {
    min-width: 80px;
    padding: 10px 5px;
    text-align: center;
    font-size: 12px;
    border-right: 1px solid #eee;
  }
  .date-item.today {
    color: #3b82f6;
    font-weight: 500;
  }

  /* 房态列表 */
  .room-list {
    background: #fff;
 
  }
  .room-row {
    border-bottom: 1px solid #eee;
  }
  .room-days {
    display: flex;
  }
  .day-cell {
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 8px 5px;
    border-right: 1px solid #eee;
    min-height: 100px;

  }
  .status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 2px;
    font-size: 12px;
    margin-bottom: 2px;
    text-align: center;
    height:60px;
    padding:4px;
  }
  .status.empty {
    background: #f3f4f6;
    color: #999;
  }
  .status.booked {
    background: #f59e0b;
    color: #fff;
  }
  .item_name{
    width:100%;
    height:18px;
    overflow: hidden;
  }
  .tag {
    font-size: 10px;
    padding: 1px 1px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.3);
    margin-top: 3px;
    display: inline-block;
  }
  



.content_status_1{
    background-color:#409EFF;
  }
  
  .status_color{
    font-size:12px;
    color:#fff;
  }
    

  .content_status_2{
    background-color:#f59e0b;
  }


  .content_status_3{
    background-color:#67C23A;
  }

 
  .content_status_4{
    background-color:#F56C6C;
  }

  .content_status_0{
    background-color:#f1f1f1;
  }

  .dialogDate{
    width:100%;
    padding:20px;
  }

  .dialogDateRow{
    display: flex;
    justify-content: space-between;
    width:100%;
    padding:20px 10px 20px 10px;
  }

  .dialogDateLable{

  }
  .dialogDateValue{

  }

  .order_title{
    padding:10px 10px;
    font-size:14px;
    font-weight:bold;
  }
  </style>




// WEBPACK FOOTER //
// src/pages/pc.vue